import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AdminAccessControlService } from '@data-terminal/data-access/route-guards/access-control/admin-access-control.service';
import { AccessControlService } from '@data-terminal/data-access/route-guards';

export const activateForCloudAdminOrMember: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    if (inject(AdminAccessControlService).canActivate()) {
        return true;
    }
    return inject(AccessControlService).canActivate(route);
};
